import React from 'react'

export default function YogaHall() {
    return (
        <div>YogaHall</div>
    )
}
